module.exports = __webpack_public_path__ + "static/media/banner-iso-pdf.85e74f56.png";